import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const DouyinCreateCommentReplyParamsSchema = ActionCommonParamsSchema.extend({
    itemId: z.string(),
    commentId: z.string(),
    text: z.string(),
});

export type DouyinCreateCommentReplyParams = z.infer<typeof DouyinCreateCommentReplyParamsSchema>;
